"use strict";
// @ts-ignore
try {
    self['workbox:expiration:7.3.0'] && _();
}
catch (e) { }
